import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import "./index.scss"
import VizSensor from "react-visibility-sensor"

class Footer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
    }
  }

  render() {
    return (
      <VizSensor
        onChange={isVisible => {
          this.setState({
            visible: isVisible,
          })
        }}
        scrollCheck={true}
      >
        <footer className={this.state.visible ? "footer visible" : "footer"}>
          <section className="footer__navigation">
            <ul className="footer__navigation__list">
              <li>
                <Link to="/impressum">Impressum</Link>
              </li>
              <li>
                <Link to="/datenschutz">Datenschutzerklärung</Link>
              </li>
              <li>
                <Link to="/kontakt">Kontakt</Link>
              </li>
            </ul>
          </section>
          <section className="footer__signature">
            made by <span className="visualy"> <a href="https://visualy.at" target="_blank" rel="noopener noreferrer">visualy.at</a></span>
          </section>
          <section className="footer__copyright">
            Copyright {new Date().getFullYear()}
          </section>
        </footer>
      </VizSensor>
    )
  }
}

export default Footer
